export const TITLE_STAR_ICON_SIZE = 21

export const TABLE_STAR_ICON_SIZE = 16

export const TABLE_PHONE_ICON_SIZE = 16
